module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/init/init.scss
// module id = ./src/app/pages/init/init.scss
// module chunks = main